import { NODE_CONTEXT_IMPORT } from "./NodeContextImportConstants";

export const NODE_CONTEXT_JSON_SHAPE_ERROR =
  NODE_CONTEXT_IMPORT.clientValidation.jsonWrongShape;

export function isValidNodeContextJsonDocument(parsed) {
  if (Array.isArray(parsed)) {
    return true;
  }
  if (
    parsed &&
    typeof parsed === "object" &&
    Array.isArray(parsed.nodes)
  ) {
    return true;
  }
  return false;
}
